export interface HelpClickedModal {
  action: string;
}
